export const makeApiUrl = (route: string) => `${process.env.API_URL}/${route}`;
export const makeApiAuthUrl = (route: string) =>
  `${process.env.API_AUTH_URL}/${route}`;
export const makeApiAccountUrl = (route: string) =>
  `${process.env.API_ACCOUNT_URL}/${route}`;
